import type { TApiResponse, TApiResponseType } from '@/types/api-types/TApiResponse'
import SpreadingJobsApiUrls from './endpoints'
import BaseApiRequest from '../BaseApiRequest'
import type {
  ISpreadingJobsApi,
  TCreateSpreadingJobRequestBody,
  TDeleteSpreadingJobParams,
  TGetSpreadingJobByIdParams,
  TGetSpreadingJobsParams,
  TUpdateSpreadingJobByIdRequestBody,
  TUpdateSpreadingJobParams
} from '@/types/api-types/spreadingJob'
import type { IBulkOperationResponseType } from '@/types/api-types/IApiResponse'
import type { TItemRequestQueryParams } from '@/types/api-types'

class SpreadingJobsApiRequest extends BaseApiRequest implements ISpreadingJobsApi {
  async getSpreadingJob(params: TGetSpreadingJobsParams): TApiResponse {
    return this.get(SpreadingJobsApiUrls.SPREADING_JOBS(), params)
  }

  async getSpreadingJobById(params: TGetSpreadingJobByIdParams): TApiResponse {
    const { id, ...rest } = params
    const url = `${SpreadingJobsApiUrls.SPREADING_JOBS_BY_ID(id)}`
    return this.get(url, rest)
  }

  async editSpreadingJob(
    params: TUpdateSpreadingJobParams,
    requestBody: TUpdateSpreadingJobByIdRequestBody
  ): TApiResponse {
    const { id, ...rest } = params
    const url = `${SpreadingJobsApiUrls.SPREADING_JOBS_BY_ID(id)}`
    return this.put(url, requestBody, rest)
  }

  async deleteSpreadingJob(
    params?: TDeleteSpreadingJobParams
  ): TApiResponseType<IBulkOperationResponseType> {
    return this.delete(SpreadingJobsApiUrls.SPREADING_JOBS(), params)
  }

  async addSpreadingJob(requestBody: TCreateSpreadingJobRequestBody, params?: TItemRequestQueryParams): TApiResponse {
    return this.post(SpreadingJobsApiUrls.SPREADING_JOBS(), requestBody, params)
  }
}

export default SpreadingJobsApiRequest
